import { PlusOutlined, WarningOutlined } from "@ant-design/icons";
import { Button, Flex, Tag } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { $t, i18n } from "~/i18n.js";
import { api } from "~/lib/api.js";
import { _parseDateTime } from "~/lib/localize.js";
import { BadgeList } from "../../badges/BadgeList.jsx";
import { HelpBubble } from "../../help/helpBubble.jsx";
import { NotitieModal } from "../../profile/notitieModal.jsx";
import { Notities } from "../../profile/tabs/notities.jsx";
import "./flightDetails.css";


// # as long as the translations are there this is not required, just in case we remove translations in admin pages
//  $t('vertrek_vliegveld')
//  $t('aankomst_vliegveld')
//  $t('callsign')
//  $t('registratie')
//  $t('type')
//  $t('gezagvoerder_naam')
//  $t('tweede_inzittende_naam',)
//  $t('is_examen')
//  $t('is_profcheck')
//  $t('is_overland')
//  $t('category',)
//  $t('start_methode')
//  $t('is_training')
//  $t('start_tijd')
//  $t('landings_tijd')
//  $t('height')
//  $t('Registratie')
//  $t('Type')
//  $t('Gezagvoerder')
//  $t('Tweede inzittende')
//  $t('examen')
//  $t('Profcheck')
//  $t('Overland')
//  $t('category')
//  $t('Start methode')
//  $t('Trainingsvlucht')
//  $t('start tijd')
//  $t('landings tijd')
//  $t('afgetekend')
//  $t('ingetrokken')
//  $t('Handtekening')
//  $t('motor_minutes')
//  $t('motor_end')
//  $t('vluchtduur')
//  $t('blocktime')

const _showValue = (value, field) => {
  if (field === "start_methode") return $t(value);
  if (field === "status") return $t(value); // $t('status') $t('zichtbaar') $t('verwijderd')
  if (field === "Handtekening") return $t(value); // $t('Handtekening') $t('afgetekend') $t('ingetrokken')
  if (field === "height") return i18n.parseLocaleHeightString(value);
  if (typeof value === "boolean") {
    return value ? "ja" : "nee";
  }
  return value === null || value === "" ? "-" : value;
};

const NotitiesTable = ({
  flight,
  profile,
  notities,
  openNotitieModal,
  title,
}) => {
  // only show notities if relevant
  if (!flight.gezagvoerder_id) return null;
  if (
    !profile.is_instructeur &&
    flight.gezagvoerder_id !== profile.id &&
    flight.tweede_inzittende_id !== profile.id
  )
    return null;
  return (
    <Flex gap={12} vertical style={{ marginTop: 12 }}>
      <div className="label">
        <span className="gray">
          {title} {$t("Instructie notities")}{" "}
        </span>
        <HelpBubble
          content={$t(
            "Als instructeur kan je per vlucht een notitie achterlaten, en zelf kiezen of hij zichtbaar is voor de vlieger."
          )}
        />
        {profile.is_instructeur && flight.gezagvoerder_id > 0 && (
          <Button
            style={{ marginLeft: 12 }}
            type="primary"
            icon={<PlusOutlined />}
            size="small"
            onClick={() => openNotitieModal(null)}
          >
            {$t("Voeg toe")}
          </Button>
        )}
      </div>
      <div style={{ marginLeft: 12 }}>
        <Notities
          flightNote
          notities={notities}
          currentUserID={profile.id}
          alleenPublic={false}
          openNotitie={(notitie) => openNotitieModal(notitie)}
        />
      </div>
    </Flex>
  );
};

export const SummaryChangedFields = ({ updates }) => {
  return (
    <table
      style={{
        background: "#f6f6f6",
        width: "auto",
        borderSpacing: "12px 0",
        marginLeft: 24,
      }}
    >
      <tbody>
        {updates?.map((update, idx) => {
          if (!update) return null;

          return (
            !update.field.includes("id") && (
              <tr key={idx}>
                <td className="truncate" style={{ marginRight: 6 }}>
                  {$t(update.field)}
                </td>

                <td className="truncate" style={{ marginRight: 6 }}>
                  {_showValue(update.from, update.field)}
                </td>
                <td>➤</td>
                <td className="truncate">
                  {_showValue(update.to, update.field)}
                </td>
              </tr>
            )
          );
        })}
      </tbody>
    </table>
  );
};

const ChangesTable = ({ changes, created, title, flight }) => {
  if (!created || !changes) return null;

  // possible fields for translation
  // $t('vertrek vliegveld'),
  // $t('aankomst vliegveld'),
  // $t('Callsign'),
  // $t('Registratie'),
  // $t('Type'),
  // $t('Gezagvoerder'),
  // $t('Tweede inzittende'),
  // $t('examen'),
  // $t('Profcheck'),
  // $t('Overland'),
  // $t('category'),
  // $t('Start methode'),
  // $t('Trainingsvlucht'),
  // $t('start tijd'),
  // $t('landings tijd'),
  // $t('height')
  // $t('afgetekend')
  // $t('ingetrokken')
  // $t('Handtekening')
  // $t('motor_minutes')
  // $t('sleep_uuid')

  return (
    <div>
      <p className="label" style={{ marginTop: 4, color: "gray" }}>
        {title || (
          <span>
            {$t("Wijzigingen")}{" "}
            <HelpBubble
              content={$t(
                "Na landing worden wijzigingen op belangrijke velden bijgehouden. Bijvoorbeeld voor velden zoals tijd, vlieger en startmethode."
              )}
            />
          </span>
        )}
      </p>

      <div className="flightChanges">
        <table style={{ width: "auto", borderSpacing: "12px 0" }}>
          <tbody>
            
            {flight?.date_updated && changes.length > 0 && flight?.date_updated != changes[0].date_created && (
              <tr>
                <td className="truncate" style={{ marginRight: 6 }}>
                  {_parseDateTime(flight.date_updated, {
                    month: "2-digit",
                    day: "2-digit",
                  })}
                </td>
                <td className="truncate" style={{ marginRight: 6 }}>
                  
                </td>
                <td className="truncate">{$t("laatste update")}</td>
              </tr>
            )}

            {changes?.map((record, key) => {
              return record?.updates?.map((update, idx) => {
                if (!update) return null;

                const field = $t(update.field);

                // alert if field is ... for training, examen and profcheck and currently true
                const alert =
                  update.field.includes("is") &&
                  update.to === true &&
                  flight[update.field] === true;

                return (
                  !update.field.includes("_id") && (
                    <tr key={`${key}-${idx}`}>
                      <td className="truncate" style={{ marginRight: 6 }}>
                        {_parseDateTime(record.date_created, {
                          month: "2-digit",
                          day: "2-digit",
                        })}
                      </td>
                      <td className="truncate" style={{ marginRight: 6 }}>
                        {record.user_name}
                      </td>

                      <td className="truncate" style={{ marginRight: 6 }}>
                        {alert ? (
                          <Tag color="red">
                            <WarningOutlined
                              style={{ fontSize: 12, marginRight: 6 }}
                            />{" "}
                            {field}
                          </Tag>
                        ) : (
                          field
                        )}
                      </td>

                      <td className="truncate" style={{ marginRight: 6 }}>
                        {_showValue(update.from, update.field)}
                      </td>
                      <td>➤</td>
                      <td className="truncate">
                        {_showValue(update.to, update.field)}
                      </td>
                    </tr>
                  )
                );
              });
            })}

            {created?.date_created && (
              <tr>
                <td className="truncate" style={{ marginRight: 6 }}>
                  {_parseDateTime(created.date_created, {
                    month: "2-digit",
                    day: "2-digit",
                  })}
                </td>
                <td className="truncate" style={{ marginRight: 6 }}>
                  {created.created || $t("Automatisch")}
                </td>
                <td className="truncate">{$t("aangemaakt")}</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export const FlightDetails = ({ flight, title = "", hideNotes = false }) => {
  const { profile } = useSelector((state) => state.persist);
  const dispatch = useDispatch();

  // for updates we retrieve it for each 
  const [badges, setBadges] = useState([]);
  const [changes, setChanges] = useState([]);
  const [created, setCreated] = useState({});
  const [notities, setNotities] = useState([]);
  useEffect(() => {
    let isMounted = true;
    if (flight && flight.id) {
      api.get(`flights/${flight.id}/get_details.json`).then((res) => {
        if (!isMounted) return;
        setBadges(res?.badges);
        setChanges(res?.changes);
        setCreated(res?.created);
        setNotities(res?.notities);
      });
    }
    return () => {
      isMounted = false;
    };
  }, [flight]);

  const [modalOpen, setModalOpen] = useState(false);
  const [notitie, setOpenNotitie] = useState(null);
  const openNotitieModal = (notitie) => {
    setOpenNotitie(
      notitie || { id: null, bericht: "", is_kritiek: false, is_prive: false }
    );
    setModalOpen(true);
  };

  const onAddNotitie = (newNote) => {
    setNotities([newNote].concat((notities || []).filter((n) => newNote.id !== n.id)));
    setModalOpen(false);
    setOpenNotitie(null);
    dispatch({
      type: "ADD_NOTITIE_TO_USER_PROFILE",
      notitie: newNote,
    });
  };

  return (
    <div>
      
      {!hideNotes && (
        <NotitieModal
          visible={modalOpen}
          onCancel={() => setModalOpen(false)}
          onOk={onAddNotitie}
          activeDay={{ dag_id: flight.dag_id, datum: flight.datum }}
          notitie={notitie}
          flight_uuid={flight.uuid}
          pilot={
            flight.is_fis && flight.tweede_inzittende_id > 0
              ? {
                  id: flight.tweede_inzittende_id,
                  name: flight.tweede_inzittende_naam,
                }
              : { id: flight.gezagvoerder_id, name: flight.gezagvoerder_naam }
          }
        />
      )}
      
      {/* TODO: BADGE REMOVAL, has_badges */}
      {/* <BadgeList badges={badges} flight={flight} /> */}

      {!hideNotes && (
        <NotitiesTable
          notities={notities}
          openNotitieModal={openNotitieModal}
          title={title}
          flight={flight}
          profile={profile}
        />
      )}

      <ChangesTable
        changes={changes}
        created={created}
        title={title}
        flight={flight}
      />
    </div>
  );
};
